import React from 'react';
import { Form } from 'react-bootstrap';
import { FormControlErrorMessage } from '../formControlErrorMessage';
import { IFormGroupProps } from './types';

export const FormGroup: React.FC<IFormGroupProps> = (props) => {
  const { name, label, required, children, ...rest } = props;

  return (
    <Form.Group controlId={`form${name}`} {...rest}>
      {label && (
        <Form.Label className={required ? 'required' : ''}>{label}</Form.Label>
      )}
      {children}
      {/*<Form.Control.Feedback>Looks good!</Form.Control.Feedback>*/}
      <FormControlErrorMessage name={name} />
    </Form.Group>
  );
};
